import React from 'react';
import { Tooltip } from 'react-tooltip';
import { Row, Col } from 'reactstrap';
import Button from '@mui/material/Button';
export const QCingFormAircraft = (
	onAircraftQCSubmit,
	currentCapture,
	imageData,
	skipCapture,
	drawnItemsValid,
	aircraftFormValue,
	setAircraftFormValue,
	aircraftCase
) => {
	return (
		<div
			style={{
				width: '100%',

			}}
			className="d-flex flex-column "
		>
			<form
				//onSubmit={(e) => onStockpilesQCSubmit(e)}
				className="mt-auto"
				id="aircraft-form"
			>

				<div
					style={{
						position: 'relative'
						//border: 'solid red 1px'
					}}
				>
					{/* BUTTONS */}
					{currentCapture && (
						<div
							//className="position-absolute bottom-0 end-0"
							style={{ width: '100%' }}
						>
							<Row>
								{aircraftCase === 1 && (
									<div>
										<p>
											Decide whether you{' '}
											<strong>
												<span className="text-success">accept</span>
											</strong>{' '}
											or{' '}
											<strong>
												<span className="text-danger">reject</span>
											</strong>{' '}
											this image. <br></br> If you find at least 90% of the
											aircraft locations to be accurate, you can{' '}
											<strong>
												<span className="text-success">accept</span>
											</strong>{' '}
											this capture.
										</p>
									</div>
								)}
								{aircraftCase === 2 && (
									<div>
										<p>
											Adjust the geometry of the aircraft or re-label the
											aircraft type as required using the map funcionality,
											then{' '}
											<strong>
												<span className="text-success">accept</span>
											</strong>{' '}
											the image and move to the next capture.
										</p>
									</div>
								)}
								{aircraftCase === 1 && (
									<div className="row mb-3">
										<div className="col d-flex justify-content-center">
											<input
												type="radio"
												className="form-check-input me-2"
												name="QC-image-aircraft-form-radios "
												//onClick={(e) => setStockpilesFormValue(0)}
												id="QC-image-aircraft-form-radios-reject"
												value={0}
											// disabled={
											// 	pipelineContextQCFormStockpiles.capsInPipeline.filter(
											// 		(cap) => cap.hasOwnProperty('beenQCd')
											// 	).length ===
											// 	pipelineContextQCFormStockpiles.capsInPipeline
											// 		.length
											// }
											></input>
											<label
												className="text-danger fw-bold"
												for="QC-image-aircraft-form-radios-reject"
											>
												Reject
											</label>
										</div>
										<div className="col d-flex justify-content-center">
											<input
												type="radio"
												className="form-check-input me-2"
												name="QC-image-stockpiles-form-radios "
												//onClick={(e) => setStockpilesFormValue(1)}
												id="QC-image-aircraft-form-radios-accept"
												value={1}
												defaultChecked={true}
											// disabled={
											// 	pipelineContextQCFormStockpiles.capsInPipeline.filter(
											// 		(cap) => cap.hasOwnProperty('beenQCd')
											// 	).length ===
											// 	pipelineContextQCFormStockpiles.capsInPipeline
											// 		.length
											// }
											></input>
											<label
												className="text-success fw-bold"
												for="QC-image-aircraft-form-radios-accept"
											>
												Accept
											</label>
										</div>
									</div>
								)}
			 <Button variant="contained">Update</Button>
							</Row>
						</div>
					)}
				</div>

			</form>
		</div>
	);
};
